module.exports = __webpack_public_path__ + "img/f4-2-2.4bb448a5.png";